import { Media } from "@docid/types/src/payload-types";

export function isMedia(obj: any): obj is Media {
    return (
        typeof obj === "object" &&
        obj !== null &&
        typeof obj.filename === "string" &&
        typeof obj.id === "string"
    );
}

export type MediaAsset = {
    url: string;
    width: number;
    height: number;
    alt: string;
}

type MediaSize = "xlarge" | "large" | "medium" | "small";

export function getMedia(media: Media): MediaAsset {
    return {
        url: `${process.env.NEXT_PUBLIC_ASSETS_CDN_URL}/media/${media.filename}`,
        width: media.width as number,
        height: media.height as number,
        alt: media.alt || "",
    };
}

export function getMediaBySize(media: Media, size: MediaSize): MediaAsset {

    const sizePriority: MediaSize[] = ["xlarge", "large", "medium", "small"];

    const startIndex = sizePriority.indexOf(size);

    for (let i = startIndex; i < sizePriority.length; i++) {

        const sizeKey = sizePriority[i];
        const size = media.sizes && media.sizes[sizeKey];
        if (size && size.width && size.height && size.filename) {
            return {
                url: `${process.env.NEXT_PUBLIC_ASSETS_CDN_URL}/media/${size.filename}`,
                width: size.width,
                height: size.height,
                alt: media.alt || "",
            };
        }

    }

    return {
        url: `${process.env.NEXT_PUBLIC_ASSETS_CDN_URL}/media/${media.filename}`,
        width: media.width as number,
        height: media.height as number,
        alt: media.alt || "",
    };

}